import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

import CenteredLoader from 'components/lib/CenteredLoader'
import Progress from 'components/lib/Progress'

import NavigationPopup from '../NavigationPopup'

import Step from './Step'

class AccountSetup extends React.Component {
  state = {
    showAccountSetupModal: false,
  }

  componentDidMount() {
    const { setOnClickCallback } = this.props
    setOnClickCallback(this.togglePopup)
    this.props.fetchSetupSteps()
    document.addEventListener('mousedown', this.handlerOutsideClick)
  }

  componentWillReceiveProps(nextProps) {
    const { todoCount, setBadgeCount } = this.props
    if (todoCount !== nextProps.todoCount) {
      setBadgeCount(nextProps.todoCount)
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.showAccountSetupModal !== nextState.showAccountSetupModal) {
      this.props.setDropdownShown(nextState.showAccountSetupModal)
    }
  }

  componentDidUpdate() {
    if (!this.props.showAccountSetupModal) {
      this.props.onCloseCallback()
    }
  }

  componentWillUnmount() {
    this.props.fetchSetupStepsCancel()
    document.removeEventListener('mousedown', this.handlerOutsideClick)
  }

  onClose = () => this.setState({ showAccountSetupModal: false })

  stopPropagation = (e) => e.stopPropagation()

  setWrapperRef = (node) => {
    this.wrapperRef = node
  }

  togglePopup = () => {
    if (!this.state.showAccountSetupModal) {
      this.props.fetchSetupSteps()
    }

    this.setState((prevState) => ({
      showAccountSetupModal: !prevState.showAccountSetupModal,
    }))
  }

  handlerOutsideClick = (e) => {
    const modal = document.querySelector('.is-modal')

    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(e.target) &&
      this.state.showAccountSetupModal &&
      typeof e.target.className === 'string' &&
      e.target.className.indexOf('main-icon') === -1 &&
      (!modal || !modal.contains(e.target))
    ) {
      this.setState({ showAccountSetupModal: false })
    }
  }

  closeDismissModal = () => {
    this.setState({ showAccountSetupModal: false })
  }

  render() {
    const { showAccountSetupModal } = this.state
    const {
      data,
      loader,
      todoCount,
      className,
      stepLoader,
      toggleDismiss,
      isStaticSalesDemo,
      popupTop,
      popupRight,
    } = this.props

    const numberOfTasks = data.filter((elem) => !elem.dismissed).length

    const completedTasks = numberOfTasks - todoCount

    return (
      <>
        {showAccountSetupModal && (
          <NavigationPopup
            ref={this.setWrapperRef}
            className={cls(className)}
            width="400px"
            id="navigation-popup"
            top={popupTop}
            right={popupRight}
          >
            <div className="content" onClick={this.stopPropagation}>
              {loader ? (
                <CenteredLoader style={{ marginTop: '70px' }} />
              ) : (
                <>
                  <div className="step-title" id="accountSetup-step-title">
                    Account Setup
                  </div>
                  <div className="completed-indication" id="accountSetup-completed-indication">
                    {numberOfTasks === completedTasks ? (
                      <span>All Completed!</span>
                    ) : (
                      <span>{`${completedTasks} out of ${numberOfTasks} tasks ${
                        completedTasks > 1 ? 'have' : 'has'
                      } been completed`}</span>
                    )}
                  </div>
                  <div className="progress-container" id="accountSetup-progress-bar">
                    <Progress
                      percent={numberOfTasks ? (completedTasks / numberOfTasks) * 100 : 100}
                      primaryColor="var(--green)"
                      size="7px"
                    />
                  </div>
                  {data.map((step) => (
                    <Step
                      key={step.step}
                      data={step}
                      loader={stepLoader[step.step]}
                      closePopup={this.onClose}
                      toggleDismiss={toggleDismiss}
                      isStaticSalesDemo={isStaticSalesDemo}
                    />
                  ))}
                </>
              )}
            </div>
          </NavigationPopup>
        )}
      </>
    )
  }
}

export default styled(AccountSetup)`
  .content {
    min-height: 130px;
  }
  .step-title {
    color: var(--color-text);
    font-weight: 600;
    padding: 10px 16px 5px 16px;
    text-transform: capitalize;
  }
  .completed-indication {
    color: var(--sub-text-color);
    font-size: 12px;
    padding: 0 16px;
    line-height: 22px;
    .next-step-indication {
      color: var(--link-text-default);
      font-weight: 600;
      font-size: 12px;
      float: right;
      cursor: pointer;
    }
  }
  .progress-container {
    padding: 10px 16px 15px 16px;
  }
  .step-item {
    color: var(--sub-text-color);
    padding: 10px 16px;
    border-top: 1px solid var(--card-border-color);
    &.marked {
      background: var(--color-surface-foreground);
    }
    .marked-indication {
      width: 35px;
      .unmarked-step {
        width: 20px;
        height: 20px;
        margin-right: 15px;
        border: 2px solid var(--input-border-color);
        border-radius: 10px;
      }
      img {
        width: 20px;
      }
    }
    .step-text {
      width: calc(100% - 35px);
      .text-indication {
        width: calc(100% - 75px);
        margin-right: 15px;
      }
      .step-actions {
        width: 60px;
        text-align: right;
        white-space: nowrap;
        & > div {
          width: 50%;
          display: inline-block;
          vertical-align: middle;
          text-align: center;
          & > * {
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
          }
          .kb-icon {
            position: relative;
            top: 2px;
          }
          .loader-container {
            height: 20px;
            cursor: default;
            .loader {
              position: relative;
              top: 0;
              left: 0;
              .ball-clip-rotate > div {
                width: 18px;
                height: 18px;
                margin: 0;
                border-color: var(--input-border-color);
                border-bottom-color: transparent;
              }
            }
          }
        }
      }
    }
  }
`
